import { render, staticRenderFns } from "./staff.vue?vue&type=template&id=231d6a61"
import script from "./staff.vue?vue&type=script&lang=tsx"
export * from "./staff.vue?vue&type=script&lang=tsx"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports